/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router"

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as appAuthImport } from "./routes/(app)/_auth"
import { Route as authNotAdminRouteImport } from "./routes/(auth)/not-admin/route"
import { Route as authLoginRouteImport } from "./routes/(auth)/login/route"
import { Route as appAuthUpsellRouteImport } from "./routes/(app)/_auth/upsell/route"
import { Route as appAuthTrendsRouteImport } from "./routes/(app)/_auth/trends/route"
import { Route as appAuthTranslationsRouteImport } from "./routes/(app)/_auth/translations/route"
import { Route as appAuthTaskEffortRouteImport } from "./routes/(app)/_auth/task-effort/route"
import { Route as appAuthSupportChatRouteImport } from "./routes/(app)/_auth/support-chat/route"
import { Route as appAuthStatsRouteImport } from "./routes/(app)/_auth/stats/route"
import { Route as appAuthPlatformFeeRouteImport } from "./routes/(app)/_auth/platform-fee/route"
import { Route as appAuthPartsRouteImport } from "./routes/(app)/_auth/parts/route"
import { Route as appAuthDefaultMessagesRouteImport } from "./routes/(app)/_auth/default-messages/route"
import { Route as appAuthComponentActionsRouteImport } from "./routes/(app)/_auth/component-actions/route"
import { Route as appAuthAlfredPricingRouteImport } from "./routes/(app)/_auth/alfred-pricing/route"
import { Route as appAuthAbTestsRouteImport } from "./routes/(app)/_auth/ab-tests/route"
import { Route as appAuthIndexRouteImport } from "./routes/(app)/_auth/index/route"
import { Route as appAuthSupportChatThreadIdRouteImport } from "./routes/(app)/_auth/support-chat/$threadId/route"
import { Route as appAuthStoresCreateRouteImport } from "./routes/(app)/_auth/stores/create/route"
import { Route as appAuthVslIndexRouteImport } from "./routes/(app)/_auth/vsl/index/route"
import { Route as appAuthVslVslIdIndexRouteImport } from "./routes/(app)/_auth/vsl/$vslId/index/route"
import { Route as appAuthVslVslIdVersionsVersionIdRouteImport } from "./routes/(app)/_auth/vsl/$vslId/versions/$versionId/route"

// Create Virtual Routes

const appImport = createFileRoute("/(app)")()

// Create/Update Routes

const appRoute = appImport.update({
  id: "/(app)",
  getParentRoute: () => rootRoute,
} as any)

const appAuthRoute = appAuthImport
  .update({
    id: "/_auth",
    getParentRoute: () => appRoute,
  } as any)
  .lazy(() => import("./routes/(app)/_auth.lazy").then((d) => d.Route))

const authNotAdminRouteRoute = authNotAdminRouteImport.update({
  id: "/(auth)/not-admin",
  path: "/not-admin",
  getParentRoute: () => rootRoute,
} as any)

const authLoginRouteRoute = authLoginRouteImport
  .update({
    id: "/(auth)/login",
    path: "/login",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(auth)/login/route.lazy").then((d) => d.Route))

const appAuthUpsellRouteRoute = appAuthUpsellRouteImport
  .update({
    id: "/upsell",
    path: "/upsell",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/upsell/route.lazy").then((d) => d.Route),
  )

const appAuthTrendsRouteRoute = appAuthTrendsRouteImport.update({
  id: "/trends",
  path: "/trends",
  getParentRoute: () => appAuthRoute,
} as any)

const appAuthTranslationsRouteRoute = appAuthTranslationsRouteImport
  .update({
    id: "/translations",
    path: "/translations",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/translations/route.lazy").then((d) => d.Route),
  )

const appAuthTaskEffortRouteRoute = appAuthTaskEffortRouteImport
  .update({
    id: "/task-effort",
    path: "/task-effort",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/task-effort/route.lazy").then((d) => d.Route),
  )

const appAuthSupportChatRouteRoute = appAuthSupportChatRouteImport
  .update({
    id: "/support-chat",
    path: "/support-chat",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/support-chat/route.lazy").then((d) => d.Route),
  )

const appAuthStatsRouteRoute = appAuthStatsRouteImport
  .update({
    id: "/stats",
    path: "/stats",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/stats/route.lazy").then((d) => d.Route),
  )

const appAuthPlatformFeeRouteRoute = appAuthPlatformFeeRouteImport
  .update({
    id: "/platform-fee",
    path: "/platform-fee",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/platform-fee/route.lazy").then((d) => d.Route),
  )

const appAuthPartsRouteRoute = appAuthPartsRouteImport
  .update({
    id: "/parts",
    path: "/parts",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/parts/route.lazy").then((d) => d.Route),
  )

const appAuthDefaultMessagesRouteRoute = appAuthDefaultMessagesRouteImport
  .update({
    id: "/default-messages",
    path: "/default-messages",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/default-messages/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthComponentActionsRouteRoute = appAuthComponentActionsRouteImport
  .update({
    id: "/component-actions",
    path: "/component-actions",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/component-actions/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthAlfredPricingRouteRoute = appAuthAlfredPricingRouteImport
  .update({
    id: "/alfred-pricing",
    path: "/alfred-pricing",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/alfred-pricing/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthAbTestsRouteRoute = appAuthAbTestsRouteImport
  .update({
    id: "/ab-tests",
    path: "/ab-tests",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/ab-tests/route.lazy").then((d) => d.Route),
  )

const appAuthIndexRouteRoute = appAuthIndexRouteImport
  .update({
    id: "/",
    path: "/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/index/route.lazy").then((d) => d.Route),
  )

const appAuthSupportChatThreadIdRouteRoute =
  appAuthSupportChatThreadIdRouteImport
    .update({
      id: "/$threadId",
      path: "/$threadId",
      getParentRoute: () => appAuthSupportChatRouteRoute,
    } as any)
    .lazy(() =>
      import("./routes/(app)/_auth/support-chat/$threadId/route.lazy").then(
        (d) => d.Route,
      ),
    )

const appAuthStoresCreateRouteRoute = appAuthStoresCreateRouteImport
  .update({
    id: "/stores/create",
    path: "/stores/create",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/stores/create/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthVslIndexRouteRoute = appAuthVslIndexRouteImport
  .update({
    id: "/vsl/",
    path: "/vsl/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/vsl/index/route.lazy").then((d) => d.Route),
  )

const appAuthVslVslIdIndexRouteRoute = appAuthVslVslIdIndexRouteImport
  .update({
    id: "/vsl/$vslId/",
    path: "/vsl/$vslId/",
    getParentRoute: () => appAuthRoute,
  } as any)
  .lazy(() =>
    import("./routes/(app)/_auth/vsl/$vslId/index/route.lazy").then(
      (d) => d.Route,
    ),
  )

const appAuthVslVslIdVersionsVersionIdRouteRoute =
  appAuthVslVslIdVersionsVersionIdRouteImport
    .update({
      id: "/vsl/$vslId/versions/$versionId",
      path: "/vsl/$vslId/versions/$versionId",
      getParentRoute: () => appAuthRoute,
    } as any)
    .lazy(() =>
      import(
        "./routes/(app)/_auth/vsl/$vslId/versions/$versionId/route.lazy"
      ).then((d) => d.Route),
    )

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/(auth)/login": {
      id: "/(auth)/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRoute
    }
    "/(auth)/not-admin": {
      id: "/(auth)/not-admin"
      path: "/not-admin"
      fullPath: "/not-admin"
      preLoaderRoute: typeof authNotAdminRouteImport
      parentRoute: typeof rootRoute
    }
    "/(app)": {
      id: "/(app)"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    "/(app)/_auth": {
      id: "/(app)/_auth"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appAuthImport
      parentRoute: typeof appRoute
    }
    "/(app)/_auth/": {
      id: "/(app)/_auth/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof appAuthIndexRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/ab-tests": {
      id: "/(app)/_auth/ab-tests"
      path: "/ab-tests"
      fullPath: "/ab-tests"
      preLoaderRoute: typeof appAuthAbTestsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/alfred-pricing": {
      id: "/(app)/_auth/alfred-pricing"
      path: "/alfred-pricing"
      fullPath: "/alfred-pricing"
      preLoaderRoute: typeof appAuthAlfredPricingRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/component-actions": {
      id: "/(app)/_auth/component-actions"
      path: "/component-actions"
      fullPath: "/component-actions"
      preLoaderRoute: typeof appAuthComponentActionsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/default-messages": {
      id: "/(app)/_auth/default-messages"
      path: "/default-messages"
      fullPath: "/default-messages"
      preLoaderRoute: typeof appAuthDefaultMessagesRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/parts": {
      id: "/(app)/_auth/parts"
      path: "/parts"
      fullPath: "/parts"
      preLoaderRoute: typeof appAuthPartsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/platform-fee": {
      id: "/(app)/_auth/platform-fee"
      path: "/platform-fee"
      fullPath: "/platform-fee"
      preLoaderRoute: typeof appAuthPlatformFeeRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/stats": {
      id: "/(app)/_auth/stats"
      path: "/stats"
      fullPath: "/stats"
      preLoaderRoute: typeof appAuthStatsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/support-chat": {
      id: "/(app)/_auth/support-chat"
      path: "/support-chat"
      fullPath: "/support-chat"
      preLoaderRoute: typeof appAuthSupportChatRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/task-effort": {
      id: "/(app)/_auth/task-effort"
      path: "/task-effort"
      fullPath: "/task-effort"
      preLoaderRoute: typeof appAuthTaskEffortRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/translations": {
      id: "/(app)/_auth/translations"
      path: "/translations"
      fullPath: "/translations"
      preLoaderRoute: typeof appAuthTranslationsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/trends": {
      id: "/(app)/_auth/trends"
      path: "/trends"
      fullPath: "/trends"
      preLoaderRoute: typeof appAuthTrendsRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/upsell": {
      id: "/(app)/_auth/upsell"
      path: "/upsell"
      fullPath: "/upsell"
      preLoaderRoute: typeof appAuthUpsellRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/vsl/": {
      id: "/(app)/_auth/vsl/"
      path: "/vsl"
      fullPath: "/vsl"
      preLoaderRoute: typeof appAuthVslIndexRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/stores/create": {
      id: "/(app)/_auth/stores/create"
      path: "/stores/create"
      fullPath: "/stores/create"
      preLoaderRoute: typeof appAuthStoresCreateRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/support-chat/$threadId": {
      id: "/(app)/_auth/support-chat/$threadId"
      path: "/$threadId"
      fullPath: "/support-chat/$threadId"
      preLoaderRoute: typeof appAuthSupportChatThreadIdRouteImport
      parentRoute: typeof appAuthSupportChatRouteImport
    }
    "/(app)/_auth/vsl/$vslId/": {
      id: "/(app)/_auth/vsl/$vslId/"
      path: "/vsl/$vslId"
      fullPath: "/vsl/$vslId"
      preLoaderRoute: typeof appAuthVslVslIdIndexRouteImport
      parentRoute: typeof appAuthImport
    }
    "/(app)/_auth/vsl/$vslId/versions/$versionId": {
      id: "/(app)/_auth/vsl/$vslId/versions/$versionId"
      path: "/vsl/$vslId/versions/$versionId"
      fullPath: "/vsl/$vslId/versions/$versionId"
      preLoaderRoute: typeof appAuthVslVslIdVersionsVersionIdRouteImport
      parentRoute: typeof appAuthImport
    }
  }
}

// Create and export the route tree

interface appAuthSupportChatRouteRouteChildren {
  appAuthSupportChatThreadIdRouteRoute: typeof appAuthSupportChatThreadIdRouteRoute
}

const appAuthSupportChatRouteRouteChildren: appAuthSupportChatRouteRouteChildren =
  {
    appAuthSupportChatThreadIdRouteRoute: appAuthSupportChatThreadIdRouteRoute,
  }

const appAuthSupportChatRouteRouteWithChildren =
  appAuthSupportChatRouteRoute._addFileChildren(
    appAuthSupportChatRouteRouteChildren,
  )

interface appAuthRouteChildren {
  appAuthIndexRouteRoute: typeof appAuthIndexRouteRoute
  appAuthAbTestsRouteRoute: typeof appAuthAbTestsRouteRoute
  appAuthAlfredPricingRouteRoute: typeof appAuthAlfredPricingRouteRoute
  appAuthComponentActionsRouteRoute: typeof appAuthComponentActionsRouteRoute
  appAuthDefaultMessagesRouteRoute: typeof appAuthDefaultMessagesRouteRoute
  appAuthPartsRouteRoute: typeof appAuthPartsRouteRoute
  appAuthPlatformFeeRouteRoute: typeof appAuthPlatformFeeRouteRoute
  appAuthStatsRouteRoute: typeof appAuthStatsRouteRoute
  appAuthSupportChatRouteRoute: typeof appAuthSupportChatRouteRouteWithChildren
  appAuthTaskEffortRouteRoute: typeof appAuthTaskEffortRouteRoute
  appAuthTranslationsRouteRoute: typeof appAuthTranslationsRouteRoute
  appAuthTrendsRouteRoute: typeof appAuthTrendsRouteRoute
  appAuthUpsellRouteRoute: typeof appAuthUpsellRouteRoute
  appAuthVslIndexRouteRoute: typeof appAuthVslIndexRouteRoute
  appAuthStoresCreateRouteRoute: typeof appAuthStoresCreateRouteRoute
  appAuthVslVslIdIndexRouteRoute: typeof appAuthVslVslIdIndexRouteRoute
  appAuthVslVslIdVersionsVersionIdRouteRoute: typeof appAuthVslVslIdVersionsVersionIdRouteRoute
}

const appAuthRouteChildren: appAuthRouteChildren = {
  appAuthIndexRouteRoute: appAuthIndexRouteRoute,
  appAuthAbTestsRouteRoute: appAuthAbTestsRouteRoute,
  appAuthAlfredPricingRouteRoute: appAuthAlfredPricingRouteRoute,
  appAuthComponentActionsRouteRoute: appAuthComponentActionsRouteRoute,
  appAuthDefaultMessagesRouteRoute: appAuthDefaultMessagesRouteRoute,
  appAuthPartsRouteRoute: appAuthPartsRouteRoute,
  appAuthPlatformFeeRouteRoute: appAuthPlatformFeeRouteRoute,
  appAuthStatsRouteRoute: appAuthStatsRouteRoute,
  appAuthSupportChatRouteRoute: appAuthSupportChatRouteRouteWithChildren,
  appAuthTaskEffortRouteRoute: appAuthTaskEffortRouteRoute,
  appAuthTranslationsRouteRoute: appAuthTranslationsRouteRoute,
  appAuthTrendsRouteRoute: appAuthTrendsRouteRoute,
  appAuthUpsellRouteRoute: appAuthUpsellRouteRoute,
  appAuthVslIndexRouteRoute: appAuthVslIndexRouteRoute,
  appAuthStoresCreateRouteRoute: appAuthStoresCreateRouteRoute,
  appAuthVslVslIdIndexRouteRoute: appAuthVslVslIdIndexRouteRoute,
  appAuthVslVslIdVersionsVersionIdRouteRoute:
    appAuthVslVslIdVersionsVersionIdRouteRoute,
}

const appAuthRouteWithChildren =
  appAuthRoute._addFileChildren(appAuthRouteChildren)

interface appRouteChildren {
  appAuthRoute: typeof appAuthRouteWithChildren
}

const appRouteChildren: appRouteChildren = {
  appAuthRoute: appAuthRouteWithChildren,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

export interface FileRoutesByFullPath {
  "/login": typeof authLoginRouteRoute
  "/not-admin": typeof authNotAdminRouteRoute
  "/": typeof appAuthIndexRouteRoute
  "/ab-tests": typeof appAuthAbTestsRouteRoute
  "/alfred-pricing": typeof appAuthAlfredPricingRouteRoute
  "/component-actions": typeof appAuthComponentActionsRouteRoute
  "/default-messages": typeof appAuthDefaultMessagesRouteRoute
  "/parts": typeof appAuthPartsRouteRoute
  "/platform-fee": typeof appAuthPlatformFeeRouteRoute
  "/stats": typeof appAuthStatsRouteRoute
  "/support-chat": typeof appAuthSupportChatRouteRouteWithChildren
  "/task-effort": typeof appAuthTaskEffortRouteRoute
  "/translations": typeof appAuthTranslationsRouteRoute
  "/trends": typeof appAuthTrendsRouteRoute
  "/upsell": typeof appAuthUpsellRouteRoute
  "/vsl": typeof appAuthVslIndexRouteRoute
  "/stores/create": typeof appAuthStoresCreateRouteRoute
  "/support-chat/$threadId": typeof appAuthSupportChatThreadIdRouteRoute
  "/vsl/$vslId": typeof appAuthVslVslIdIndexRouteRoute
  "/vsl/$vslId/versions/$versionId": typeof appAuthVslVslIdVersionsVersionIdRouteRoute
}

export interface FileRoutesByTo {
  "/login": typeof authLoginRouteRoute
  "/not-admin": typeof authNotAdminRouteRoute
  "/": typeof appAuthIndexRouteRoute
  "/ab-tests": typeof appAuthAbTestsRouteRoute
  "/alfred-pricing": typeof appAuthAlfredPricingRouteRoute
  "/component-actions": typeof appAuthComponentActionsRouteRoute
  "/default-messages": typeof appAuthDefaultMessagesRouteRoute
  "/parts": typeof appAuthPartsRouteRoute
  "/platform-fee": typeof appAuthPlatformFeeRouteRoute
  "/stats": typeof appAuthStatsRouteRoute
  "/support-chat": typeof appAuthSupportChatRouteRouteWithChildren
  "/task-effort": typeof appAuthTaskEffortRouteRoute
  "/translations": typeof appAuthTranslationsRouteRoute
  "/trends": typeof appAuthTrendsRouteRoute
  "/upsell": typeof appAuthUpsellRouteRoute
  "/vsl": typeof appAuthVslIndexRouteRoute
  "/stores/create": typeof appAuthStoresCreateRouteRoute
  "/support-chat/$threadId": typeof appAuthSupportChatThreadIdRouteRoute
  "/vsl/$vslId": typeof appAuthVslVslIdIndexRouteRoute
  "/vsl/$vslId/versions/$versionId": typeof appAuthVslVslIdVersionsVersionIdRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/(auth)/login": typeof authLoginRouteRoute
  "/(auth)/not-admin": typeof authNotAdminRouteRoute
  "/(app)": typeof appRouteWithChildren
  "/(app)/_auth": typeof appAuthRouteWithChildren
  "/(app)/_auth/": typeof appAuthIndexRouteRoute
  "/(app)/_auth/ab-tests": typeof appAuthAbTestsRouteRoute
  "/(app)/_auth/alfred-pricing": typeof appAuthAlfredPricingRouteRoute
  "/(app)/_auth/component-actions": typeof appAuthComponentActionsRouteRoute
  "/(app)/_auth/default-messages": typeof appAuthDefaultMessagesRouteRoute
  "/(app)/_auth/parts": typeof appAuthPartsRouteRoute
  "/(app)/_auth/platform-fee": typeof appAuthPlatformFeeRouteRoute
  "/(app)/_auth/stats": typeof appAuthStatsRouteRoute
  "/(app)/_auth/support-chat": typeof appAuthSupportChatRouteRouteWithChildren
  "/(app)/_auth/task-effort": typeof appAuthTaskEffortRouteRoute
  "/(app)/_auth/translations": typeof appAuthTranslationsRouteRoute
  "/(app)/_auth/trends": typeof appAuthTrendsRouteRoute
  "/(app)/_auth/upsell": typeof appAuthUpsellRouteRoute
  "/(app)/_auth/vsl/": typeof appAuthVslIndexRouteRoute
  "/(app)/_auth/stores/create": typeof appAuthStoresCreateRouteRoute
  "/(app)/_auth/support-chat/$threadId": typeof appAuthSupportChatThreadIdRouteRoute
  "/(app)/_auth/vsl/$vslId/": typeof appAuthVslVslIdIndexRouteRoute
  "/(app)/_auth/vsl/$vslId/versions/$versionId": typeof appAuthVslVslIdVersionsVersionIdRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/login"
    | "/not-admin"
    | "/"
    | "/ab-tests"
    | "/alfred-pricing"
    | "/component-actions"
    | "/default-messages"
    | "/parts"
    | "/platform-fee"
    | "/stats"
    | "/support-chat"
    | "/task-effort"
    | "/translations"
    | "/trends"
    | "/upsell"
    | "/vsl"
    | "/stores/create"
    | "/support-chat/$threadId"
    | "/vsl/$vslId"
    | "/vsl/$vslId/versions/$versionId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/not-admin"
    | "/"
    | "/ab-tests"
    | "/alfred-pricing"
    | "/component-actions"
    | "/default-messages"
    | "/parts"
    | "/platform-fee"
    | "/stats"
    | "/support-chat"
    | "/task-effort"
    | "/translations"
    | "/trends"
    | "/upsell"
    | "/vsl"
    | "/stores/create"
    | "/support-chat/$threadId"
    | "/vsl/$vslId"
    | "/vsl/$vslId/versions/$versionId"
  id:
    | "__root__"
    | "/(auth)/login"
    | "/(auth)/not-admin"
    | "/(app)"
    | "/(app)/_auth"
    | "/(app)/_auth/"
    | "/(app)/_auth/ab-tests"
    | "/(app)/_auth/alfred-pricing"
    | "/(app)/_auth/component-actions"
    | "/(app)/_auth/default-messages"
    | "/(app)/_auth/parts"
    | "/(app)/_auth/platform-fee"
    | "/(app)/_auth/stats"
    | "/(app)/_auth/support-chat"
    | "/(app)/_auth/task-effort"
    | "/(app)/_auth/translations"
    | "/(app)/_auth/trends"
    | "/(app)/_auth/upsell"
    | "/(app)/_auth/vsl/"
    | "/(app)/_auth/stores/create"
    | "/(app)/_auth/support-chat/$threadId"
    | "/(app)/_auth/vsl/$vslId/"
    | "/(app)/_auth/vsl/$vslId/versions/$versionId"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  authLoginRouteRoute: typeof authLoginRouteRoute
  authNotAdminRouteRoute: typeof authNotAdminRouteRoute
  appRoute: typeof appRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  authLoginRouteRoute: authLoginRouteRoute,
  authNotAdminRouteRoute: authNotAdminRouteRoute,
  appRoute: appRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(auth)/login",
        "/(auth)/not-admin",
        "/(app)"
      ]
    },
    "/(auth)/login": {
      "filePath": "(auth)/login/route.tsx"
    },
    "/(auth)/not-admin": {
      "filePath": "(auth)/not-admin/route.tsx"
    },
    "/(app)": {
      "filePath": "(app)",
      "children": [
        "/(app)/_auth"
      ]
    },
    "/(app)/_auth": {
      "filePath": "(app)/_auth.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/_auth/",
        "/(app)/_auth/ab-tests",
        "/(app)/_auth/alfred-pricing",
        "/(app)/_auth/component-actions",
        "/(app)/_auth/default-messages",
        "/(app)/_auth/parts",
        "/(app)/_auth/platform-fee",
        "/(app)/_auth/stats",
        "/(app)/_auth/support-chat",
        "/(app)/_auth/task-effort",
        "/(app)/_auth/translations",
        "/(app)/_auth/trends",
        "/(app)/_auth/upsell",
        "/(app)/_auth/vsl/",
        "/(app)/_auth/stores/create",
        "/(app)/_auth/vsl/$vslId/",
        "/(app)/_auth/vsl/$vslId/versions/$versionId"
      ]
    },
    "/(app)/_auth/": {
      "filePath": "(app)/_auth/index/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/ab-tests": {
      "filePath": "(app)/_auth/ab-tests/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/alfred-pricing": {
      "filePath": "(app)/_auth/alfred-pricing/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/component-actions": {
      "filePath": "(app)/_auth/component-actions/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/default-messages": {
      "filePath": "(app)/_auth/default-messages/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/parts": {
      "filePath": "(app)/_auth/parts/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/platform-fee": {
      "filePath": "(app)/_auth/platform-fee/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/stats": {
      "filePath": "(app)/_auth/stats/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/support-chat": {
      "filePath": "(app)/_auth/support-chat/route.tsx",
      "parent": "/(app)/_auth",
      "children": [
        "/(app)/_auth/support-chat/$threadId"
      ]
    },
    "/(app)/_auth/task-effort": {
      "filePath": "(app)/_auth/task-effort/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/translations": {
      "filePath": "(app)/_auth/translations/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/trends": {
      "filePath": "(app)/_auth/trends/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/upsell": {
      "filePath": "(app)/_auth/upsell/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/vsl/": {
      "filePath": "(app)/_auth/vsl/index/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/stores/create": {
      "filePath": "(app)/_auth/stores/create/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/support-chat/$threadId": {
      "filePath": "(app)/_auth/support-chat/$threadId/route.tsx",
      "parent": "/(app)/_auth/support-chat"
    },
    "/(app)/_auth/vsl/$vslId/": {
      "filePath": "(app)/_auth/vsl/$vslId/index/route.tsx",
      "parent": "/(app)/_auth"
    },
    "/(app)/_auth/vsl/$vslId/versions/$versionId": {
      "filePath": "(app)/_auth/vsl/$vslId/versions/$versionId/route.tsx",
      "parent": "/(app)/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
